export default __webpack_public_path__ + "static/jobbox-2-b-a781665efcd92c3c01a2161dc75f3861.webp";